exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".s53cr616guttcued2248w2vm89nmmzpe33cyzh5et9dvzju674yx76p8mwqe6atv7prcxg89g95wpkqqa1xb1s2u8qstn49daetqww-InfiniteLoader-module-infiniteLoader{padding:12px 0}", "", {"version":3,"sources":["C:/a/_work/5/s/src/components/InfiniteLoader/C:/a/_work/5/s/src/components/InfiniteLoader/InfiniteLoader.module.scss"],"names":[],"mappings":"AAAA,6IACE,cAAe,CAChB","file":"InfiniteLoader.module.scss","sourcesContent":[".infiniteLoader {\r\n  padding: 12px 0;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"infiniteLoader": "s53cr616guttcued2248w2vm89nmmzpe33cyzh5et9dvzju674yx76p8mwqe6atv7prcxg89g95wpkqqa1xb1s2u8qstn49daetqww-InfiniteLoader-module-infiniteLoader"
};